const estimated_delivery_date = 100;

export {
  estimated_delivery_date
}